/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const Favorite = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      {...props}
      data-palette="Favorite">
      <path
        fill="var(--brand-bg-primary)"
        d="M3.686 11.2a.653.653 0 01-.374-.118.617.617 0 01-.248-.642l.772-3.312-2.618-2.236a.611.611 0 01-.187-.66.637.637 0 01.549-.427L5.044 3.5 6.414.377A.634.634 0 017 0c.255 0 .485.148.586.377l1.37 3.122 3.464.306c.255.023.47.19.549.427a.61.61 0 01-.187.66l-2.618 2.236.772 3.312a.611.611 0 01-.248.641.652.652 0 01-.701.03L7 9.372l-2.987 1.74a.658.658 0 01-.327.088zM7 8.623c.113 0 .226.03.327.089l2.82 1.642-.73-3.126a.612.612 0 01.203-.606l2.472-2.111-3.271-.29a.633.633 0 01-.53-.376L7 .9 5.707 3.846a.632.632 0 01-.528.375l-3.271.289L4.38 6.62a.612.612 0 01.202.606l-.728 3.126 2.819-1.641A.643.643 0 017 8.622z"
      />
    </svg>)
  );
};

export default Favorite;
